let ecommerceReferer: string | undefined

export const setEcommerceReferer = (value?: string) => {
  ecommerceReferer = value
}

export const getEcommerceReferer = () => {
  return ecommerceReferer
}
